var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",class:{ 'full-width': !_vm.auth.isLoggedIn },attrs:{"id":"appFooter"}},[_vm._v("\n    © "+_vm._s(new Date().getFullYear())+" - Cruz Roja Argentina Filial Corrientes.\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66ddacfa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
// module id = Erng
// module chunks = 1